import NextImage from "next/image";
import React, { useEffect, useRef, useState } from "react";
import { useUpdateDoctorsInfoMutation, useUpdateDoctorsProfileMutation, useUpdateDoctorsQualificationMutation, useUpdatePasswordMutation, useUpdateTwoFactorMutation } from "../../../Redux/apis/doctor";
import uploadFileToS3 from "../../../utils/file.upload";
import { useDispatch, useSelector } from "react-redux";
import { userData } from "../../../Redux/apis/userData";
import ImageCropper from "../../Common/ImageCropper/ImageCropper";
import CoverImageCropper from "../../Common/ImageCropper/CoverImageCropper";
import Avatar from "react-avatar";
import { sanitizeImageUrl, firstValidProfileUrl } from "@/utils/imageUrl";
import { useForm } from "react-hook-form";
import { useDegreeQuery, useSpecialityQuery } from "@/Redux/apis/content";
import { RiTimeZoneLine } from "react-icons/ri";
import { listTimezone } from "@/utils/common";
import { toast } from "react-toastify";
const DoctorsEditProfile = ({
  onClose
}) => {
  const users = useSelector(state => state?.userData?.userData?.user);
  const token = useSelector(state_0 => state_0?.token?.token);
  const [activeTab, setActiveTab] = useState("Profile Picture");
  const [mainHeaderTab, setHeaderTab] = useState("Edit Profile");
  const [SecurityTab, setSecurityTab] = useState("Password");
  const [showPassword, setShowPassword] = useState(false);
  const [degreeList, setDegreeList] = useState();
  const [specialityList, setSpecialityList] = useState();
  const [imageError, setImageError] = useState();
  const [loading, setLoading] = useState(false);
  // Use the same multi-field lookup as the navbar / Header so we don't
  // miss images stored in `profile` while only `profileImage`/`logo` is
  // checked. Older accounts wrote to `profile`, newer flows write to
  // `profileImage` (physicians) or `logo` (reps/clinics). Reading all
  // three keeps the edit dialog in sync with what every other surface
  // shows. firstValidProfileUrl also filters out dead-AWS URLs.
  const profilePic = firstValidProfileUrl(users);
  const coverPic = users?.cover;
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  console.log("users", users);
  const EditTabs = ["Profile Picture", "Profile Details", "Profile Cover", "Qualification Details", "Account Appearance"];
  const SecurityTabs = ["Password", "Authentication"];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    register,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm({
    defaultValues: {
      "firstName": users?.firstName || "",
      "lastName": users?.lastName || "",
      "email": users?.email || "",
      "timezone": users?.timezone || ""
    }
  });
  const {
    register: updatePasswordForm,
    handleSubmit: handleUpdatePasswordForm,
    formState: {
      errors: updatePasswordError
    },
    watch
  } = useForm();
  const {
    register: qualificationForm,
    handleSubmit: handleQualificationFormSubmit,
    formState: {
      errors: qualificationFormErrors
    }
  } = useForm({
    defaultValues: {
      speciality: users?.speciality || "",
      degree: users?.degree || "",
      experience: users?.experience || ""
    }
  });
  const degreeData = useDegreeQuery({
    refetchOnMountOrArgChange: true
  });
  useEffect(() => {
    if (!degreeData.isLoading) {
      // Sort alphabetically so the dropdown matches the signup form.
      const list = degreeData?.data?.degreelist || [];
      const sorted = [...list].sort((a, b) => String(a?.degree || "").localeCompare(String(b?.degree || "")));
      setDegreeList(sorted);
    }
  }, [degreeData?.data, degreeData?.isLoading, degreeData?.isError]);
  const specialityData = useSpecialityQuery({
    refetchOnMountOrArgChange: true
  });
  useEffect(() => {
    if (!specialityData.isLoading) {
      // Sort alphabetically so the dropdown matches the order on the
      // signup form (ProfileSetting.jsx) — picking your speciality
      // when re-editing should land on the same row in the list.
      const list_0 = specialityData?.data?.Specialitylist || [];
      const sorted_0 = [...list_0].sort((a_0, b_0) => String(a_0?.speciality || "").localeCompare(String(b_0?.speciality || "")));
      setSpecialityList(sorted_0);
    }
  }, [specialityData?.data, specialityData?.isLoading, specialityData?.isError]);
  const [doctorProfileUpdate, doctorResponse] = useUpdateDoctorsProfileMutation();
  const [doctorInfoUpdate, doctorInfoResponse] = useUpdateDoctorsInfoMutation();
  const [doctorQualificationUpdate, doctorQualificationResponse] = useUpdateDoctorsQualificationMutation();
  const [updatePassword, updatePasswordResponse] = useUpdatePasswordMutation();
  const [updateTwoFactor, updateTwoFactorResponse] = useUpdateTwoFactorMutation();
  const handleSaveChanges = () => {
    const currentIndex = EditTabs.indexOf(activeTab);
    const nextIndex = (currentIndex + 1) % EditTabs.length;
    setActiveTab(EditTabs[nextIndex]);
  };
  const handleSaveAndProceed = () => {
    const currentIndex_0 = SecurityTabs.indexOf(SecurityTab);
    const nextIndex_0 = (currentIndex_0 + 1) % SecurityTabs.length;
    setSecurityTab(SecurityTabs[nextIndex_0]);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };
  const [is2FAEnabled, setIs2FAEnabled] = useState(!!users?.twoFactorStatus);
  const handleToggle = () => {
    setIs2FAEnabled(!is2FAEnabled);
  };
  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  // Image loading states
  const [isProfileImgLoading, setIsProfileImgLoading] = useState(true);
  const [isCoverImgLoading, setIsCoverImgLoading] = useState(true);
  const [isAppearanceImgLoading, setIsAppearanceImgLoading] = useState(true);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  const handleImageChange = event => {
    setImageError(null);
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        resetFileInput();
        setImageError('Please upload a valid image file.');
        return;
      }
      const reader = new FileReader();
      reader.onload = e => {
        const dataUrl = e.target.result;
        const img = new window.Image();
        img.onload = () => {
          if (img.width >= 500 && img.height >= 500) {
            setImageError(null);
            setSelectedProfileFile(file);
            setIsProfileImgLoading(true);
            openModal();
          } else {
            setImageError('Image dimensions must be at least 500x500 pixels.');
          }
          resetFileInput();
        };
        img.onerror = () => {
          setImageError('Invalid image file.');
          resetFileInput();
        };
        img.src = dataUrl;
      };
      reader.onerror = () => {
        setImageError('Error reading the file.');
        resetFileInput();
      };
      reader.readAsDataURL(file);
    }
  };
  const [selectedCoverImage, setSelectedCoverImage] = useState(null);
  const [selectedCoverPicFile, setSelectedCoverPicFile] = useState(null);
  const [isCoverModalOpen, setIsCoverModalOpen] = useState(false);
  const openCoverModal = () => {
    setIsCoverModalOpen(true);
  };
  const closeCoverModal = () => {
    setIsCoverModalOpen(false);
  };
  const handleCoverImageChange = e_0 => {
    const file_0 = e_0.target.files[0];
    setSelectedCoverPicFile(file_0);
    if (file_0) {
      setIsCoverImgLoading(true);
      openCoverModal();
    }
  };
  const HandleDoctorUploadProfile = async () => {
    setLoading(true);
    try {
      let profileFileUrl = "";
      let coverFileUrl = "";
      if (!selectedProfileFile && !selectedCoverPicFile) {
        toast.error("Please select the file!");
        setLoading(false);
        return;
      }
      if (selectedProfileFile) {
        profileFileUrl = await uploadFileToS3({
          folder: "physicians",
          file: selectedProfileFile,
          setLoading: setLoading
        });
      }
      if (selectedCoverPicFile) {
        coverFileUrl = await uploadFileToS3({
          folder: "physicians",
          file: selectedCoverPicFile,
          setLoading: setLoading
        });
      }
      const formDataToSend = {
        id: users?._id,
        ...(profileFileUrl ? {
          profile: profileFileUrl
        } : {}),
        ...(coverFileUrl ? {
          cover: coverFileUrl
        } : {})
      };
      await doctorProfileUpdate(formDataToSend);
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };
  const HandleDoctorInfoProfile = async data => {
    setLoading(true);
    try {
      data.id = users?._id;
      await doctorInfoUpdate(data);
      setLoading(false);
    } catch (error_0) {
      console.error("Error:", error_0);
      setLoading(false);
    }
  };
  const HandleUpdatePassword = async data_0 => {
    setLoading(true);
    try {
      data_0.id = users?._id;
      await updatePassword(data_0);
      setLoading(false);
    } catch (error_1) {
      console.error("Error:", error_1);
      setLoading(false);
    }
  };
  const updateTwoFactorStatus = async () => {
    setLoading(true);
    try {
      let dataToSend = {
        id: users?._id,
        twoFactorStatus: is2FAEnabled
      };
      await updateTwoFactor(dataToSend);
      setLoading(false);
    } catch (error_2) {
      console.error("Error:", error_2);
      setLoading(false);
    }
  };
  const HandleDoctorQualificationProfile = async data_1 => {
    setLoading(true);
    try {
      data_1.id = users?._id;
      await doctorQualificationUpdate(data_1);
      setLoading(false);
    } catch (error_3) {
      console.error("Error:", error_3);
      setLoading(false);
    }
  };
  useEffect(() => {
    const handleDoctorResponse = async () => {
      if (doctorResponse?.isLoading) {
        setLoading(true);
      } else if (!doctorResponse?.isLoading && doctorResponse?.isSuccess) {
        const data_2 = {
          token: token
        };
        toast.success("Profile updated successfully");
        await dispatch(userData(data_2)); // Wait for userData to be updated
        setLoading(false);
      } else if (doctorResponse?.isError && doctorResponse?.status === "rejected" && doctorResponse?.error?.status === 400) {
        toast.error(doctorResponse?.error?.data?.message);
        setLoading(false);
      }
    };
    handleDoctorResponse();
  }, [doctorResponse]);
  useEffect(() => {
    const handleDoctorTwoFectorResponse = async () => {
      if (updateTwoFactorResponse?.isLoading) {
        setLoading(true);
      } else if (!updateTwoFactorResponse?.isLoading && updateTwoFactorResponse?.isSuccess) {
        const data_3 = {
          token: token
        };
        toast.success(`Profile updated successfully`);
        await dispatch(userData(data_3)); // Wait for userData to be updated
        setLoading(false);
      } else if (updateTwoFactorResponse?.isError && updateTwoFactorResponse?.status === "rejected" && updateTwoFactorResponse?.error?.status === 400) {
        toast.error(updateTwoFactorResponse?.error?.data?.message);
        setLoading(false);
      }
    };
    handleDoctorTwoFectorResponse();
  }, [updateTwoFactorResponse]);
  useEffect(() => {
    const handleDoctorInfoResponse = async () => {
      if (doctorInfoResponse?.isLoading) {
        setLoading(true);
      } else if (!doctorInfoResponse?.isLoading && doctorInfoResponse?.isSuccess) {
        const data_4 = {
          token: token
        };
        toast.success(`Profile updated successfully`);
        await dispatch(userData(data_4)); // Wait for userData to be updated
        setLoading(false);
      } else if (doctorInfoResponse?.isError) {
        toast.error(doctorInfoResponse?.error?.data?.message || "Unable to update your profile. Please try again.");
        setLoading(false);
      }
    };
    handleDoctorInfoResponse();
  }, [doctorInfoResponse]);
  useEffect(() => {
    const handleUpdatePasswordResponse = async () => {
      if (updatePasswordResponse?.isLoading) {
        setLoading(true);
      } else if (!updatePasswordResponse?.isLoading && updatePasswordResponse?.isSuccess) {
        const data_5 = {
          token: token
        };
        toast.success("Profile updated successfully");
        await dispatch(userData(data_5)); // Wait for userData to be updated
        setLoading(false);
      } else if (updatePasswordResponse?.isError && updatePasswordResponse?.status === "rejected" && updatePasswordResponse?.error?.status === 400) {
        toast.error(updatePasswordResponse?.error?.data?.message);
        setLoading(false);
      }
    };
    handleUpdatePasswordResponse();
  }, [updatePasswordResponse]);
  useEffect(() => {
    const handleDoctorQualificationResponse = async () => {
      if (doctorQualificationResponse?.isLoading) {
        setLoading(true);
      } else if (!doctorQualificationResponse?.isLoading && doctorQualificationResponse?.isSuccess) {
        const data_6 = {
          token: token
        };
        toast.success(`Profile updated successfully`);
        await dispatch(userData(data_6)); // Wait for userData to be updated
        setLoading(false);
      } else if (doctorQualificationResponse?.isError && doctorQualificationResponse?.status === "rejected" && doctorQualificationResponse?.error?.status === 400) {
        toast.error(doctorQualificationResponse?.error?.data?.message);
        setLoading(false);
      }
    };
    handleDoctorQualificationResponse();
  }, [doctorQualificationResponse]);
  const newPasswordValue = watch("password");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  return <>
      <div className="fixed inset-0 popup-bg z-[100] flex justify-center items-end sm:items-center">
        <div className="w-full sm:w-[750px] h-full sm:h-auto sm:max-h-[90vh] sm:min-h-[332px] rounded-none sm:rounded-2xl bg-white flex flex-col overflow-hidden">
          <div className="flex items-center justify-between w-full px-3 sm:px-4 pt-3 sm:pt-3.5 border-b flex-shrink-0">
            <div className="flex items-center gap-4 sm:gap-8 overflow-x-auto scrollbar-hide flex-1">
            <div className={`text-xs sm:text-[14px] cursor-pointer pb-2 font-poppins whitespace-nowrap ${mainHeaderTab === "Edit Profile" ? "bg-[#FAFAFA] text-[#354EF0] border-[#354EF0] border-b-2 font-medium" : "text-[#1F1F1F] font-normal"}`} onClick={() => setHeaderTab("Edit Profile")}>
              Edit Profile
            </div>
            <div className={`text-xs sm:text-[14px] cursor-pointer pb-2 font-poppins whitespace-nowrap ${mainHeaderTab === "Security Settings" ? "bg-[#FAFAFA] text-[#354EF0] border-[#354EF0] border-b-2 font-medium" : "text-[#1F1F1F] font-normal"}`} onClick={() => setHeaderTab("Security Settings")}>
              Security Settings
            </div>
            </div>
            <div onClick={onClose} className="w-6 h-6 cursor-pointer flex-shrink-0 ml-3 mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M5.00073 17.5864C4.61023 17.977 4.61029 18.6101 5.00085 19.0006C5.39141 19.3911 6.02457 19.3911 6.41506 19.0005L12.0003 13.4143L17.586 19C17.9765 19.3905 18.6097 19.3905 19.0002 19C19.3907 18.6095 19.3907 17.9763 19.0002 17.5858L13.4144 12L18.9998 6.41362C19.3902 6.02306 19.3902 5.3899 18.9996 4.99941C18.6091 4.60891 17.9759 4.60897 17.5854 4.99953L12.0001 10.5858L6.41438 5.00001C6.02386 4.60949 5.39069 4.60949 5.00017 5.00001C4.60964 5.39054 4.60964 6.0237 5.00017 6.41423L10.5861 12.0001L5.00073 17.5864Z" fill="#8E8E8E" />
              </svg>
            </div>
          </div>
          {mainHeaderTab === "Edit Profile" && <div className="flex flex-col sm:flex-row w-full flex-1 overflow-hidden">
              {/* Sidebar - Horizontal scroll on mobile, vertical on desktop */}
              <div className="w-full sm:w-[40%] border-b sm:border-b-0 sm:border-r border-[#E1E1EE] flex-shrink-0 overflow-x-scroll sm:overflow-x-visible overflow-y-hidden [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                <div className="inline-flex sm:flex sm:flex-col w-max sm:w-full px-3 sm:px-0 py-2 sm:py-0 gap-2 sm:gap-0">
                  <div className={`text-xs sm:text-[14px] py-2 sm:py-4 px-4 sm:px-4 hover:bg-[#354EF00A] hover:text-[#1E5EFF] cursor-pointer font-poppins whitespace-nowrap rounded-full sm:rounded-none border sm:border-0 flex-shrink-0 ${activeTab === "Profile Picture" ? "bg-[#354EF0] sm:bg-[#FAFAFA] text-white sm:text-[#354EF0] font-medium border-[#354EF0]" : "text-[#1F1F1F] font-normal border-gray-200 sm:border-transparent"}`} onClick={() => setActiveTab("Profile Picture")}>
                    Profile Picture
                  </div>
                  <div className={`text-xs sm:text-[14px] py-2 sm:py-4 px-4 sm:px-4 hover:bg-[#354EF00A] hover:text-[#1E5EFF] cursor-pointer font-poppins whitespace-nowrap rounded-full sm:rounded-none border sm:border-0 flex-shrink-0 ${activeTab === "Profile Details" ? "bg-[#354EF0] sm:bg-[#FAFAFA] text-white sm:text-[#354EF0] font-medium border-[#354EF0]" : "text-[#1F1F1F] font-normal border-gray-200 sm:border-transparent"}`} onClick={() => setActiveTab("Profile Details")}>
                    Profile Details
                  </div>
                  {users?.type !== "clinic" && <div className={`text-xs sm:text-[14px] py-2 sm:py-4 px-4 sm:px-4 hover:bg-[#354EF00A] hover:text-[#1E5EFF] cursor-pointer font-poppins whitespace-nowrap rounded-full sm:rounded-none border sm:border-0 flex-shrink-0 ${activeTab === "Qualification Details" ? "bg-[#354EF0] sm:bg-[#FAFAFA] text-white sm:text-[#354EF0] font-medium border-[#354EF0]" : "text-[#1F1F1F] font-normal border-gray-200 sm:border-transparent"}`} onClick={() => setActiveTab("Qualification Details")}>
                      Qualification
                    </div>}
                  <div className={`text-xs sm:text-[14px] py-2 sm:py-4 px-4 sm:px-4 hover:bg-[#354EF00A] hover:text-[#1E5EFF] cursor-pointer font-poppins whitespace-nowrap rounded-full sm:rounded-none border sm:border-0 flex-shrink-0 ${activeTab === "Account Appearance" ? "bg-[#354EF0] sm:bg-[#FAFAFA] text-white sm:text-[#354EF0] font-medium border-[#354EF0]" : "text-[#1F1F1F] font-normal border-gray-200 sm:border-transparent"}`} onClick={() => setActiveTab("Account Appearance")}>
                    Appearance
                  </div>
                </div>
              </div>

              {activeTab === "Profile Picture" && <div className="w-full sm:w-[60%] p-3 sm:p-4 flex flex-col flex-1 overflow-y-auto sm:overflow-visible">
                  <div className="text-sm sm:text-[16px] font-semibold font-poppins text-[#2E0B34]">
                    Set your profile picture
                  </div>
                  <div className="text-xs sm:text-[14px] font-normal font-poppins text-[#8E8E8E] py-2 sm:py-3">
                    Uploading your recent picture as profile image is recommended
                  </div>
                  <div className="flex flex-col sm:flex-row w-full items-center gap-3 sm:gap-4">
                    <div className="w-[70px] h-[70px] sm:w-[88px] sm:h-[88px] aspect-square rounded-lg relative overflow-hidden flex-shrink-0">
                      {(selectedProfileFile || profilePic) && isProfileImgLoading && <div className="absolute inset-0 flex items-center justify-center">
                          <div className="h-5 w-5 border-2 border-gray-300 border-t-[#354EF0] rounded-full animate-spin" />
                        </div>}
                      {selectedProfileFile && <NextImage src={URL.createObjectURL(selectedProfileFile)} alt="user" width={88} height={88} className="w-full h-full object-cover rounded-lg aspect-square" key={`${selectedProfileFile.name}-${selectedProfileFile.lastModified}`} onLoad={() => setIsProfileImgLoading(false)} onLoadingComplete={() => setIsProfileImgLoading(false)} />}
                      {!selectedProfileFile && sanitizeImageUrl(profilePic) && <NextImage src={profilePic} alt="user" width={88} height={88} className="w-full h-full object-cover rounded-lg aspect-square" key={profilePic} onLoad={() => setIsProfileImgLoading(false)} onLoadingComplete={() => setIsProfileImgLoading(false)} />}
                      {/* Initials fallback — fires when the user has no
                          uploaded image AND no loadable existing image
                          (e.g. their saved URL points at the dead AWS
                          bucket). Keeps the upload slot visually filled
                          instead of leaving an empty 88px hole next to
                          the Choose File button. */}
                      {!selectedProfileFile && !sanitizeImageUrl(profilePic) && <Avatar name={`${users?.firstName || ""} ${users?.lastName || ""}`.trim() || "?"} size="88" textSizeRatio={2} className="w-full h-full !rounded-lg" round="8px" />}
                    </div>
                    <div className="w-full">
                      <div className="text-black text-[10px] sm:text-[12px] font-medium font-poppins text-center sm:text-left">
                        Please upload an image with dimensions of at least <strong>500x500 pixels</strong>.
                      </div>
                      <div className="flex items-center gap-2 sm:gap-4">
                        <div className="flex items-center gap-2 sm:gap-4 bg-[#FAFAFA] py-2 rounded-lg px-2 sm:px-3 mt-3 sm:mt-4 w-full flex-wrap sm:flex-nowrap">
                          <label htmlFor="fileInput" className="text-[#354EF0] font-poppins border px-3 sm:px-6 py-1.5 sm:py-2 border-[#354EF0] rounded-lg font-medium text-[11px] sm:text-[12px] cursor-pointer whitespace-nowrap">
                            Choose File
                          </label>
                          <input id="fileInput" type="file" accept="image/*" className="hidden" onChange={handleImageChange} ref={fileInputRef} />
                          <div className="text-xs sm:text-[14px] font-medium font-poppins text-[#1F1F1F] truncate">
                            {imageFile ? imageFile.name : ""}
                          </div>
                        </div>
                      </div>
                      {imageError && <span className="text-red-500 text-xs sm:text-sm mt-2 block">{imageError}</span>}
                    </div>
                  </div>
                  {/* Fixed Bottom Button */}
                  <div className="w-full flex justify-end mt-auto sm:mt-6 pt-4 sm:pt-0 border-t sm:border-t-0 border-gray-100 flex-shrink-0 bg-white">
                    <button disabled={loading} onClick={HandleDoctorUploadProfile} className="text-xs sm:text-[14px] font-medium text-white rounded-lg font-poppins bg-[#354EF0] px-4 sm:px-6 py-2 w-full sm:w-auto">
                      {loading ? "Loading..." : "Save Changes"}
                    </button>
                  </div>
                  {isModalOpen && <ImageCropper selectedProfileFile={selectedProfileFile} setSelectedProfileFile={setSelectedProfileFile} closeModal={closeModal} />}
                </div>}
              {activeTab === "Profile Details" && <form onSubmit={handleSubmit(HandleDoctorInfoProfile)} className="w-full sm:w-[60%] p-3 sm:p-4 flex flex-col flex-1 overflow-y-auto sm:overflow-visible">
                  <div className="text-sm sm:text-[16px] text-[#2E0B34] font-semibold font-poppins">
                    Update your profile details
                  </div>
                  <div className="text-xs sm:text-[14px] font-normal font-poppins text-[#8E8E8E] py-2 sm:py-3">
                    You can update your name here. Your email is read-only.
                  </div>

                  {/* First Name Field */}
                  <div className="pt-1">
                    <div className="text-xs sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                      First Name
                    </div>
                    <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-1.5 sm:mt-2">
                      <div className="flex-shrink-0">
                        <NextImage src={"/Images/userIcon.svg"} width={18} height={18} alt="user" className="w-[18px] h-[18px] sm:w-5 sm:h-5" />
                      </div>
                      <input type="text" placeholder="Enter First Name" {...register("firstName", {
                  required: true
                })} className="w-full py-2 sm:py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm sm:text-base" />
                    </div>
                    {errors.firstName && <span className="text-red-500 text-xs sm:text-sm">First Name is required</span>}
                  </div>

                  {/* Last Name Field */}
                  <div className="pt-2 sm:pt-3">
                    <div className="text-xs sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                      Last Name
                    </div>
                    <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-1.5 sm:mt-2">
                      <div className="flex-shrink-0">
                        <NextImage src={"/Images/userIcon.svg"} width={18} height={18} alt="user" className="w-[18px] h-[18px] sm:w-5 sm:h-5" />
                      </div>
                      <input type="text" placeholder="Enter Last Name" {...register("lastName", {
                  required: true
                })} className="w-full py-2 sm:py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm sm:text-base" />
                    </div>
                    {errors.lastName && <span className="text-red-500 text-xs sm:text-sm">Last Name is required</span>}
                  </div>

                  {/* Email Field */}
                  <div className="pt-2 sm:pt-3">
                    <div className="text-xs sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                      Email
                    </div>
                    <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-1.5 sm:mt-2">
                      <div className="flex-shrink-0">
                        <NextImage src={"/Images/emailicon.svg"} width={18} height={18} alt="email" className="w-[18px] h-[18px] sm:w-5 sm:h-5" />
                      </div>
                      <input type="email" placeholder="Someone@example.com" {...register("email", {
                  required: true,
                  pattern: /^\S+@\S+$/i
                })} readOnly className="w-full py-2 sm:py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm sm:text-base" />
                    </div>
                    {errors.email && <span className="text-red-500 text-xs sm:text-sm">Enter a valid email</span>}
                  </div>

                  {/* Timezone Field */}
                  <div className="pt-2 sm:pt-3">
                    <div className="text-xs sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                      Timezone
                    </div>
                    <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-1.5 sm:mt-2">
                      <div className="flex-shrink-0">
                        <RiTimeZoneLine className="w-[18px] h-[18px] sm:w-5 sm:h-5 text-gray-500" />
                      </div>
                      <select {...register("timezone", {
                  required: true
                })} className="w-full py-2 sm:py-2.5 border-none outline-none rounded-lg text-sm sm:text-base bg-transparent">
                        {listTimezone()?.map((timezone, index) => <option key={index} value={timezone}>{timezone}</option>)}
                      </select>
                    </div>
                    {errors.timezone && <span className="text-red-500 text-xs sm:text-sm">Enter a valid timezone</span>}
                  </div>

                  {/* Save Button */}
                  <div className="w-full flex justify-end mt-auto sm:mt-6 pt-4 sm:pt-0 border-t sm:border-t-0 border-gray-100 flex-shrink-0 bg-white">
                    <button type="submit" className="text-xs sm:text-[14px] font-medium text-white rounded-lg font-poppins bg-[#354EF0] px-4 sm:px-6 py-2 w-full sm:w-auto">
                      {loading ? "Loading..." : "Save Changes"}
                    </button>
                  </div>
                </form>}
              {activeTab === "Profile Cover" && <div className="w-full sm:w-[60%] p-3 sm:p-4 flex flex-col flex-1 overflow-y-auto sm:overflow-visible">
                  <div className="text-[#2E0B34] text-sm sm:text-[16px] font-semibold font-poppins">
                    Set your profile cover
                  </div>
                  <div className="text-xs sm:text-[14px] text-[#8E8E8E] font-normal font-poppins py-2 sm:py-3">
                    Upload your profile cover image
                  </div>
                  <div className="w-full h-[100px] sm:h-[120px] rounded-lg relative overflow-hidden">
                    {(selectedCoverPicFile || coverPic) && isCoverImgLoading && <div className="absolute inset-0 flex items-center justify-center">
                        <div className="h-5 w-5 border-2 border-gray-300 border-t-[#354EF0] rounded-full animate-spin" />
                      </div>}
                    {selectedCoverPicFile && <NextImage src={URL.createObjectURL(selectedCoverPicFile)} alt="user" width={88} height={88} className="w-full h-full object-cover rounded-lg" onLoad={() => setIsCoverImgLoading(false)} onLoadingComplete={() => setIsCoverImgLoading(false)} />}
                    {!selectedCoverPicFile && coverPic && <NextImage src={coverPic} alt="cover" width={88} height={88} className="w-full h-full object-cover rounded-lg" onLoad={() => setIsCoverImgLoading(false)} onLoadingComplete={() => setIsCoverImgLoading(false)} />}
                    <input id="coverImageInput" type="file" accept="image/*" className="hidden" onChange={handleCoverImageChange} />
                  </div>
                  <div className="py-2 sm:py-3 text-black text-[11px] sm:text-[12px] font-semibold font-poppins">
                    Please upload image size less than 100KB
                  </div>
                  <div className="flex items-center gap-2 sm:gap-4">
                    <div className="flex items-center gap-2 sm:gap-4 bg-[#FAFAFA] py-2 rounded-lg px-2 sm:px-3 w-full flex-wrap sm:flex-nowrap">
                      <label htmlFor="coverImageInput" className="text-[#354EF0] font-poppins border px-3 sm:px-6 py-1.5 sm:py-2 border-[#354EF0] rounded-lg font-medium text-[11px] sm:text-[12px] cursor-pointer whitespace-nowrap">
                        Choose File
                      </label>
                      <div className="text-xs sm:text-[14px] font-medium font-poppins text-[#1F1F1F] truncate">
                        {selectedCoverPicFile ? selectedCoverPicFile.name : ""}
                      </div>
                    </div>
                  </div>
                  <div className="w-full flex justify-end mt-auto sm:mt-6 pt-4 sm:pt-0 border-t sm:border-t-0 border-gray-100 flex-shrink-0 bg-white">
                    <button onClick={HandleDoctorUploadProfile} className="text-xs sm:text-[14px] font-medium text-white rounded-lg font-poppins bg-[#354EF0] px-4 sm:px-6 py-2 w-full sm:w-auto">
                      {loading ? "Loading..." : "Save Changes"}
                    </button>
                  </div>
                  {isCoverModalOpen && <CoverImageCropper selectedCoverPicFile={selectedCoverPicFile} setSelectedCoverPicFile={setSelectedCoverPicFile} closeCoverModal={closeCoverModal} />}
                </div>}
              {activeTab === "Qualification Details" && <form onSubmit={handleQualificationFormSubmit(HandleDoctorQualificationProfile)} className="w-full sm:w-[60%] p-3 sm:p-4 flex flex-col flex-1 overflow-y-auto sm:overflow-visible">
                  <div className="text-sm sm:text-[16px] font-semibold font-poppins text-[#2E0B34]">
                    Your qualification details
                  </div>

                  {/* Degree Selection */}
                  <div className="text-xs sm:text-[14px] font-medium font-poppins text-[#8E8E8E] pt-3 sm:pt-4">
                    Your degree
                  </div>
                  <div className="w-full pt-1.5">
                    <div className="select_box w-full px-3 sm:px-4 pt-2 sm:pt-2.5 pb-2 sm:pb-[9px] rounded-[10px] border border-blue-600 bg-neutral-100 justify-between inline-flex self-stretch">
                      <select {...qualificationForm("degree", {
                  required: "Please select a degree"
                })} className="border-none w-full outline-none bg-neutral-100 text-sm sm:text-base" value={qualificationForm.degree}>
                        <option disabled selected hidden className="cursor-pointer" value="">
                          Select Degree
                        </option>
                        {degreeList ? degreeList?.map((ele, index_0) => <option key={index_0} className="cursor-pointer" value={ele?.degree}>
                                  {ele?.degree}
                                </option>) : ""}
                      </select>
                    </div>
                    {qualificationFormErrors.degree && <span className="text-red-500 text-xs sm:text-sm">
                        {qualificationFormErrors.degree.message}
                      </span>}
                  </div>

                  {/* Speciality Selection */}
                  <div className="text-xs sm:text-[14px] font-medium font-poppins text-[#8E8E8E] pt-3 sm:pt-4">
                    Your speciality
                  </div>
                  <div className="w-full pt-1.5">
                    <div className="select_box w-full px-3 sm:px-4 pt-2 sm:pt-2.5 pb-2 sm:pb-[9px] rounded-[10px] border border-blue-600 bg-neutral-100 justify-between inline-flex self-stretch">
                      <select {...qualificationForm("speciality", {
                  required: "Please select a speciality"
                })} className="border-none w-full outline-none bg-neutral-100 text-sm sm:text-base" value={qualificationForm.speciality}>
                        <option disabled selected hidden className="cursor-pointer" value="">
                          Select Speciality
                        </option>
                        {specialityList ? specialityList?.map((ele_0, index_1) => <option key={index_1} className="cursor-pointer" value={ele_0?.speciality}>
                                  {ele_0?.speciality}
                                </option>) : ""}
                      </select>
                    </div>
                    {qualificationFormErrors.speciality && <span className="text-red-500 text-xs sm:text-sm">
                        {qualificationFormErrors.speciality.message}
                      </span>}
                  </div>

                  {/* Experience Input */}
                  <div className="text-xs sm:text-[14px] font-medium font-poppins text-[#8E8E8E] pt-3 sm:pt-4">
                    Years of Experience
                  </div>
                  <div className="w-full pt-1.5">
                    <div className="w-full px-3 sm:px-4 pt-2 sm:pt-2.5 pb-2 sm:pb-[9px] rounded-[10px] border border-blue-600 bg-neutral-100 justify-between inline-flex self-stretch">
                      <input type="number" min="0" placeholder="Enter years of experience" className="border-none w-full outline-none bg-neutral-100 text-sm sm:text-base" {...qualificationForm("experience", {
                  required: "Experience is required",
                  min: {
                    value: 0,
                    message: "Experience cannot be negative"
                  }
                })} />
                    </div>
                    {qualificationFormErrors.experience && <span className="text-red-500 text-xs sm:text-sm">
                        {qualificationFormErrors.experience.message}
                      </span>}
                  </div>

                  {/* Save Changes Button */}
                  <div className="w-full flex justify-end mt-auto sm:mt-6 pt-4 sm:pt-0 border-t sm:border-t-0 border-gray-100 flex-shrink-0 bg-white">
                    <button type="submit" className="text-xs sm:text-[14px] font-medium text-white rounded-lg font-poppins bg-[#354EF0] px-4 sm:px-6 py-2 w-full sm:w-auto" disabled={loading}>
                      {loading ? "Loading..." : "Save Changes"}
                    </button>
                  </div>
                </form>}
              {activeTab === "Account Appearance" && <div className="w-full sm:w-[60%] p-3 sm:p-4 flex flex-col flex-1 overflow-y-auto sm:overflow-visible">
                  <div className="text-sm sm:text-[16px] font-semibold font-poppins text-[#2E0B34]">
                    Set how you appear on Alpha.MD
                  </div>
                  <div className="text-xs sm:text-[14px] font-normal font-poppins py-2 sm:py-3 text-[#8E8E8E]">
                    Uploading your recent picture as profile image is recommended
                  </div>
                  <div className="border w-full border-[#354EF0] bg-[#354EF014] rounded-lg p-2">
                    <div className="flex items-center gap-2 sm:gap-3">
                      <div className="w-[48px] h-[48px] sm:w-[56px] sm:h-[56px] rounded-lg aspect-square relative overflow-hidden flex-shrink-0">
                        {profilePic && isAppearanceImgLoading && <div className="absolute inset-0 flex items-center justify-center">
                            <div className="h-4 w-4 border-2 border-gray-300 border-t-[#354EF0] rounded-full animate-spin" />
                          </div>}
                        {sanitizeImageUrl(profilePic) && <NextImage width={50} height={50} src={profilePic} className="w-full h-full rounded-lg object-cover" alt="user" key={`appearance-${profilePic}`} onLoad={() => setIsAppearanceImgLoading(false)} onLoadingComplete={() => setIsAppearanceImgLoading(false)} />}
                        {/* Initials fallback for the Appearance preview
                            chip — same reasoning as the Profile Picture
                            tab above. */}
                        {!sanitizeImageUrl(profilePic) && <Avatar name={`${users?.firstName || ""} ${users?.lastName || ""}`.trim() || "?"} size="56" textSizeRatio={2} className="w-full h-full !rounded-lg" round="8px" />}
                      </div>
                      <div className="min-w-0">
                        <div className="text-sm sm:text-[16px] font-medium text-[#1F1F1F] font-poppins truncate">
                          {users?.firstName} {users?.lastName}
                        </div>
                        <div className="text-[#8E8E8E] text-[10px] sm:text-[11px] font-poppins font-medium pt-0.5 sm:pt-1 truncate">
                          {users?.degree}, {users?.speciality}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pt-2 sm:pt-3">
                    <div className="text-xs sm:text-[14px] font-medium text-[#8E8E8E] font-poppins">
                      Show your -
                    </div>
                    <div className="flex items-center gap-1 text-xs sm:text-[14px] font-normal text-[#8E8E8E] font-poppins">
                      <span className="inline-block w-1 h-1 bg-neutral-400 rounded-full flex-shrink-0"></span>
                      {users?.firstName} {users?.lastName}
                    </div>
                    {users?.type !== "clinic" && <div className="flex items-center gap-1 text-xs sm:text-[14px] font-normal text-[#8E8E8E] font-poppins">
                        <span className="inline-block w-1 h-1 bg-neutral-400 rounded-full flex-shrink-0"></span>
                        {users?.degree}, {users?.speciality}
                      </div>}
                  </div>
                </div>}
            </div>}
          {mainHeaderTab === "Security Settings" && <div className="flex flex-col sm:flex-row w-full flex-1 overflow-hidden">
              {/* Sidebar - Horizontal scroll on mobile, vertical on desktop */}
              <div className="w-full sm:w-[40%] border-b sm:border-b-0 sm:border-r border-[#E1E1EE] flex-shrink-0 overflow-x-scroll sm:overflow-x-visible overflow-y-hidden [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                <div className="inline-flex sm:flex sm:flex-col w-max sm:w-full px-3 sm:px-0 py-2 sm:py-0 gap-2 sm:gap-0">
                  <div className={`text-xs sm:text-[14px] py-2 sm:py-4 hover:bg-[#354EF00A] hover:text-[#1E5EFF] px-4 sm:px-4 cursor-pointer font-poppins whitespace-nowrap rounded-full sm:rounded-none border sm:border-0 flex-shrink-0 ${SecurityTab === "Password" ? "bg-[#354EF0] sm:bg-[#FAFAFA] text-white sm:text-[#354EF0] font-medium border-[#354EF0]" : "text-[#1F1F1F] font-normal border-gray-200 sm:border-transparent"}`} onClick={() => setSecurityTab("Password")}>
                    Password
                  </div>

                  <div className={`text-xs sm:text-[14px] hover:bg-[#354EF00A] hover:text-[#1E5EFF] py-2 sm:py-4 px-4 sm:px-4 cursor-pointer font-poppins whitespace-nowrap rounded-full sm:rounded-none border sm:border-0 flex-shrink-0 ${SecurityTab === "Authentication" ? "bg-[#354EF0] sm:bg-[#FAFAFA] text-white sm:text-[#354EF0] font-medium border-[#354EF0]" : "text-[#1F1F1F] font-normal border-gray-200 sm:border-transparent"}`} onClick={() => setSecurityTab("Authentication")}>
                    2-Factor Auth
                  </div>
                </div>
              </div>
              {SecurityTab === "Password" && <form onSubmit={handleUpdatePasswordForm(HandleUpdatePassword)} className="w-full sm:w-[60%] p-3 sm:p-4 flex flex-col flex-1 overflow-y-auto sm:overflow-visible">
                  <div className="text-[#2E0B34] text-sm sm:text-[16px] font-semibold font-poppins">
                    Update your password
                  </div>
                  <div className="text-[#8E8E8E] text-xs sm:text-[14px] font-normal py-2 sm:py-3 font-poppins">
                    Keep your account secure with a strong password
                  </div>

                  {/* Current Password */}
                  <div className="pt-1">
                    <div className="text-xs sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                      Current Password
                    </div>
                    <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-1.5 sm:mt-2">
                      <input type={showCurrentPassword ? "text" : "password"} placeholder="Enter Current Password" className="w-full py-2 sm:py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm sm:text-base" {...updatePasswordForm("currentPassword", {
                  required: "Current password is required"
                })} />
                      <NextImage src={showCurrentPassword ? "/Images/showEye.svg" : "/Images/hideEye.svg"} alt={showCurrentPassword ? "Hide password" : "Show password"} width={14} height={14} onClick={() => setShowCurrentPassword(prev => !prev)} className="cursor-pointer flex-shrink-0" />
                    </div>
                    {updatePasswordError.currentPassword && <span className="text-red-500 text-xs sm:text-sm">
                        {updatePasswordError.currentPassword.message}
                      </span>}
                  </div>

                  {/* New Password */}
                  <div className="pt-2 sm:pt-3">
                    <div className="text-xs sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                      New Password
                    </div>
                    <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-1.5 sm:mt-2">
                      <input type={showNewPassword ? "text" : "password"} placeholder="Enter New Password" className="w-full py-2 sm:py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm sm:text-base" {...updatePasswordForm("password", {
                  required: "New password is required",
                  pattern: {
                    value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
                    message: "Password must include at least one letter, one number, and one special character, and be at least 6 characters long"
                  }
                })} />
                      <NextImage src={showNewPassword ? "/Images/showEye.svg" : "/Images/hideEye.svg"} alt={showNewPassword ? "Hide password" : "Show password"} width={14} height={14} onClick={() => setShowNewPassword(prev_0 => !prev_0)} className="cursor-pointer flex-shrink-0" />
                    </div>
                    {updatePasswordError.password && <span className="text-red-500 text-xs sm:text-sm">
                        {updatePasswordError.password.message}
                      </span>}
                  </div>

                  {/* Repeat New Password */}
                  <div className="pt-2 sm:pt-3">
                    <div className="text-xs sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                      Repeat New Password
                    </div>
                    <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-1.5 sm:mt-2">
                      <input type={showConfirmPassword ? "text" : "password"} placeholder="Repeat New Password" className="w-full py-2 sm:py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm sm:text-base" {...updatePasswordForm("confirmPassword", {
                  required: "Please confirm your new password",
                  validate: value => value === newPasswordValue || "Passwords do not match"
                })} />
                      <NextImage src={showConfirmPassword ? "/Images/showEye.svg" : "/Images/hideEye.svg"} alt={showConfirmPassword ? "Hide password" : "Show password"} width={14} height={14} onClick={() => setShowConfirmPassword(prev_1 => !prev_1)} className="cursor-pointer flex-shrink-0" />
                    </div>
                    {updatePasswordError.confirmPassword && <span className="text-red-500 text-xs sm:text-sm">
                        {updatePasswordError.confirmPassword.message}
                      </span>}
                  </div>

                  {/* Save Changes Button */}
                  <div className="w-full flex justify-end mt-auto sm:mt-6 pt-4 sm:pt-0 border-t sm:border-t-0 border-gray-100 flex-shrink-0 bg-white">
                    <button type="submit" className="text-xs sm:text-[14px] font-medium text-white rounded-lg font-poppins bg-[#354EF0] px-4 sm:px-6 py-2 w-full sm:w-auto" disabled={loading}>
                      {loading ? "Loading..." : "Save Changes"}
                    </button>
                  </div>
                </form>}
              {SecurityTab === "Authentication" && <div className="w-full sm:w-[60%] p-3 sm:p-4 flex flex-col flex-1 overflow-y-auto sm:overflow-visible">
                  <div className="text-sm sm:text-[16px] font-semibold font-poppins text-[#2E0B34]">
                    2 Factor Authentication
                  </div>
                  <div className="text-[#8E8E8E] text-xs sm:text-[14px] font-normal font-poppins py-2 sm:py-3">
                    You can enable 2 Factor Authentication
                  </div>

                  <div className="text-[#8E8E8E] text-xs sm:text-[14px] pt-1 font-normal font-poppins">
                    Status
                  </div>
                  <div onClick={handleToggle} className={`${is2FAEnabled ? "bg-blue-600" : "bg-gray-300"} relative inline-flex h-6 w-11 items-center rounded-full mt-2 cursor-pointer transition-colors duration-300`}>
                    <span className={`${is2FAEnabled ? "translate-x-6" : "translate-x-1"} inline-block h-4 w-4 transform bg-white rounded-full transition-transform duration-300`} />
                  </div>

                  <div className="text-[#8E8E8E] text-xs sm:text-[14px] pt-2 sm:pt-3 font-normal font-poppins">
                    Email
                  </div>
                  <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-1.5 sm:mt-2">
                    <input disabled value={users?.email} placeholder="" className="w-full py-2 sm:py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm sm:text-base bg-transparent" />
                  </div>
                  <div className="w-full flex justify-end mt-auto sm:mt-6 pt-4 sm:pt-0 border-t sm:border-t-0 border-gray-100 flex-shrink-0 bg-white">
                    <button onClick={updateTwoFactorStatus} className="text-xs sm:text-[14px] font-medium text-white rounded-lg font-poppins bg-[#354EF0] px-4 sm:px-6 py-2 w-full sm:w-auto">
                      {loading ? "Loading..." : "Save Changes"}
                    </button>
                  </div>
                </div>}
            </div>}
        </div>
      </div>
    </>;
};
export default DoctorsEditProfile;